import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircleIcon } from 'lucide-react';
const includes = [{
  title: 'El eBook Completo',
  description: '"Gato Zen: Fin a los maullidos nocturnos" (Paso a paso detallado).'
}, {
  title: 'El Método 15-5-10',
  description: 'La técnica de juego que agota el sistema nervioso del gato en minutos.'
}, {
  title: 'Guía de la "Cena Táctica"',
  description: 'Qué y cuándo darle de comer para inducir el sueño postprandial.'
}, {
  title: 'Protocolo de Respuesta Cero',
  description: 'Cómo reaccionar a las 3 AM para extinguir el maullido para siempre.'
}, {
  title: 'Checklist de "Habitación Blindada"',
  description: 'Configuración del ambiente para el silencio total.'
}];
export function WhatYouGet() {
  return <section className="py-10 sm:py-14 relative" data-id="element-226">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-227">
        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center" data-id="element-228">
          <div className="mb-10 lg:mb-0" data-id="element-229">
            <FadeIn data-id="element-230">
              <h2 className="text-3xl sm:text-4xl font-bold mb-6" data-id="element-231">
                ¿Qué incluye el Kit Gato Zen?
              </h2>
            </FadeIn>

            <div className="space-y-4" data-id="element-232">
              {includes.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-233">
                  <div className="flex gap-4 p-4 rounded-xl bg-navy-light/50 border border-white/5 hover:border-gold/30 transition-colors" data-id="element-234">
                    <CheckCircleIcon className="h-6 w-6 text-gold shrink-0" data-id="element-235" />
                    <div data-id="element-236">
                      <h3 className="font-bold text-slate-100 text-lg" data-id="element-237">
                        {item.title}
                      </h3>
                      <p className="text-slate-400 font-sans mt-1" data-id="element-238">
                        {item.description}
                      </p>
                    </div>
                  </div>
                </FadeIn>)}
            </div>
          </div>

          <FadeIn direction="left" delay={0.3} data-id="element-239">
            <div className="relative mx-auto w-full max-w-md lg:max-w-none" data-id="element-240">
              <div className="absolute -inset-4 z-0 bg-gradient-radial from-gold/20 to-transparent opacity-50 blur-2xl" data-id="element-241" />
              <img src="https://cdn.magicpatterns.com/uploads/3wNJ8cPmdAYXx6vMg6UdiJ/Mockup.png" alt="Kit Gato Zen" className="relative z-10 w-full rounded-2xl shadow-2xl ring-1 ring-white/10" data-id="element-242" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}